import Head from "next/head";
import { CMS_NAME, HOME_OG_IMAGE_URL, SITE_URL } from "../../lib/constants";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";

export default function Meta({ seo, preview = false }) {
  const { asPath } = useRouter();
  // Vercel redirects trailing-slash URLs to their slashless equivalent, so use
  // that URL consistently for both canonical and Open Graph metadata.
  const rawPathname = asPath.split("?")[0].replace(/\/$/, "") || "/";
  // Next.js can expose the home page as `/index`, while the public URL and
  // sitemap use `/`. Keep all canonical signals on the public root URL.
  const pathname = rawPathname === "/index" ? "/" : rawPathname;
  const canonicalUrl = `${SITE_URL}${pathname}`;

  return (
    <>
    {seo && (
      <NextSeo
        title={seo.title ? seo.title : "Sustainable Capital Advisors"}
        description={seo.metaDesc ? seo.metaDesc : "Sustainable Capital Advisors"}
        canonical={canonicalUrl}
        noindex={preview}
        openGraph={{
          type: seo.opengraphType ? seo.opengraphType : "article",
          url: canonicalUrl,
          title: seo.opengraphTitle ? seo.opengraphTitle : seo.opengraphTitle,
          description: seo.opengraphDescription
            ? seo.opengraphDescription
            : seo.description,
          site_name: seo.opengraphPublisher,
          images: seo?.opengraphImage?.sourceUrl
            ? [
                {
                  url: seo?.opengraphImage?.sourceUrl,
                },
              ]
            : [],
        }}
      />
    )}
    <Head>
      {!seo && <link rel="canonical" href={canonicalUrl} />}
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon/favicon.png"
      />
      <link rel="shortcut icon" href="/favicon/favicon.ico" />
    </Head>
    </>
  );
}
